import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";

export interface IExtraData {
  property: IProperty;
  contract: IContract;
  previousContract?: IContract;
}

export enum EField {
  MoveDate = "moveDate",
  VacancyPropertyContract = "vacancyPropertyContract",
  ResidentCount = "residentCount",
  DepartingTenant = "departingTenantAccountId",
  VacancyPropertyContractHolder = "vacancyPropertyContractHolderAccountId",
  Services = "services",

  DepartingTenantTitle = "departingTenantTitle",
  DepartingTenantFirstName = "departingTenantFirstName",
  DepartingTenantLastName = "departingTenantLastName",
  DepartingTenantEmail = "departingTenantEmail",
}
